import { gql, useQuery, useLazyQuery } from "@apollo/client";
import { Job } from "../../executionTypes";

export const GET_JOB_DETAILS = gql`
  query getJobDetails($jobId: ID!) {
    getJobDetails(input: { jobId: $jobId }) {
      job {
        id
        activityId
        name
        description
        status
        statusReason
        createdAt
        startedAt
        stoppedAt
        createdBy
        image {
          id
          name
          description
          environmentType
          environmentTypeVersion
          validationType
          validationTypeVersion
          digest
          updatedOn
          packages {
            name
            version
          }
          validatedPackages {
            name
            version
          }
          addons {
            name
          }
        }
        actionId
        actionType
        qualityCheckStatus
        entrypoint {
          repositoryId
          versionId
        }
        inputs {
          repositoryId
          versionId
        }
        inputFolderStructure
        workingDir
        userCommand
        commands
        numOfNodes
        environmentVariables {
          name
          value
        }
        vCPU
        memory
        timeout
        ignorePatterns
        describePatterns
        parentJob {
          id
        }
        interactiveEnvironmentId
      }
    }
  }
`;

export function useGetJobDetails(jobId: string) {
  const {
    data: getJobDetails,
    loading: isGetJobLoading,
    error: errorGetJob,
    refetch: refetchJob
  } = useQuery(GET_JOB_DETAILS, {
    variables: { jobId },
    context: { clientName: "execution" },
    notifyOnNetworkStatusChange: true,
    fetchPolicy: "network-only"
  });

  const job = getJobDetails
    ? (getJobDetails?.getJobDetails?.job as Job)
    : ({} as Job);
  return {
    job,
    isGetJobLoading,
    errorGetJob,
    refetchJob
  };
}

export function useLazyGetJobDetails() {
  const [
    getJobDetails,
    { data: getJobDetailsData, loading: isGetJobLoading, error: errorGetJob }
  ] = useLazyQuery(GET_JOB_DETAILS, {
    context: { clientName: "execution" },
    notifyOnNetworkStatusChange: true,
    fetchPolicy: "network-only"
  });

  const job = getJobDetailsData
    ? (getJobDetailsData?.getJobDetails?.job as Job)
    : ({} as Job);
  return {
    getJobDetails,
    job,
    isGetJobLoading,
    errorGetJob
  };
}
